import { ViewModel, View, ObservableArray } from "binder"
import { PeriodicWarehouseCheckUpView } from "./periodicWarehouseCheckUp-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import moment from "moment";
import { ServerConnection } from "src/server/serverConnection";
import { WarehousePlacement, batchPlacementUpdater } from "../warehousePlacementManipulation/warehousePlacementManipulation-viewModel";
import { warehouseLocationSearchSelectorViewModel } from "../warehouseLocationManipulation/warehouseLocationManipulation-viewModel";
import { ExcelExporter, stringIsNullOrEmpty } from "src/common/utilities";
import { Converters } from "src/uicomponents/converters";
import { SendToLocalNotificationMessage } from "src/server/localNotification";

export class PeriodicWarehouseCheckUpViewModel extends WindowViewModel {
    public getTitle(): string {
        return "برسی دوره ای انبار";
    }

    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 15);
        this.warehouseCheckUps = ObservableArray.create<WarehouseCheckUp>();
        this.refresh();
    }

    GetDefaultView(): View<ViewModel> {
        return new PeriodicWarehouseCheckUpView();
    }

    public getTypeId(): string {
        return "VM-F03EFC70-8DB3-41F9-B333-2AB00B50ADCD"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set warehouseCheckUps(v: ObservableArray<WarehouseCheckUp>) { this._warehouseCheckUps = v; } public get warehouseCheckUps(): ObservableArray<WarehouseCheckUp> { return this._warehouseCheckUps; } private _warehouseCheckUps: ObservableArray<WarehouseCheckUp>;

    refresh() {
        this.loader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer("Complex/WarehouseServices/GetWorkerWarehouseCheckUps", {
                FilteringInformation: filteringInformation
            });
            this.warehouseCheckUps.update(...serverResult.WarehouseCheckUps.map((item, index) => {
                let checkUpItem = new WarehouseCheckUp(this);
                checkUpItem.index = index + 1;
                checkUpItem.id = item.Id;
                checkUpItem.warehouseCheckUpId = item.WarehouseCheckUpId;
                checkUpItem.creationTime = item.CreationTime;
                checkUpItem.productName = item.ProductName;
                checkUpItem.productCode = item.ProductCode;
                checkUpItem.productIndex = item.ProductIndex;
                checkUpItem.carModelName = item.CarModelName;
                checkUpItem.brandName = item.BrandName;
                checkUpItem.countryName = item.CountryName;
                checkUpItem.warehouseName = item.WarehouseName;
                checkUpItem.balance = item.Balance;
                checkUpItem.newBalance = item.NewBalance;
                checkUpItem.colorName = item.ColorName;
                checkUpItem.isChecked = item.IsChecked;
                checkUpItem.personnelName = item.PersonnelFullName;
                checkUpItem.locations =  item.Locations;
                checkUpItem.newLocations = item.NewLocations;
                checkUpItem.setWarehouseId(item.WarehouseId);
                checkUpItem.updateNewLocations(item.CurrentWarehousePlaces);
                checkUpItem.checkTime = item.CheckTime;
                checkUpItem.comment = item.Comment;
                return checkUpItem;
            }))
            return new PaginationInfo(serverResult.PaginationInfo.CurrentPage, serverResult.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async printUncheckedWarehouseCheckUps(){
        let NUMBER_OF_RECORD = 40;
        new PrintUncheckedWarehouseCheckUp(this).Print(NUMBER_OF_RECORD);
    }

}

export class WarehouseCheckUp extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: PeriodicWarehouseCheckUpViewModel) {
        super(parent);
        this._typedParent = parent;
        this.currentWarehousePlaces = ObservableArray.create<Location>();
    }

    private _typedParent;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productIndex(v: string) { this._productIndex = v; } public get productIndex(): string { return this._productIndex;} private _productIndex: string;
    public set carModelName(v: string) { this._carModelName = v; } public get carModelName(): string { return this._carModelName; } private _carModelName: string;
    public set brandName(v: string) { this._brandName = v; } public get brandName(): string { return this._brandName; } private _brandName: string;
    public set countryName(v: string) { this._countryName = v; } public get countryName(): string { return this._countryName; } private _countryName: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId; } private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance; } private _balance: number;
    public set newBalance(v: number) { this._newBalance = v; } public get newBalance(): number { return this._newBalance; } private _newBalance: number;
    public set colorName(v: string) { this._colorName = v; } public get colorName(): string { return this._colorName; } private _colorName: string;
    public set locations(v: string) { this._locations = v; } public get locations(): string { return this._locations;} private _locations: string;
    public set newLocations(v: string) { this._newLocations = v; } public get newLocations(): string { return this._newLocations;} private _newLocations: string;
    public set currentWarehousePlaces(v: ObservableArray<Location>) { this._currentWarehousePlaces = v; } public get currentWarehousePlaces(): ObservableArray<Location> { return this._currentWarehousePlaces;} private _currentWarehousePlaces: ObservableArray<Location>;
    public set warehouseLocationSelector(v: warehouseLocationSearchSelectorViewModel) { this._warehouseLocationSelector = v; } public get warehouseLocationSelector(): warehouseLocationSearchSelectorViewModel { return this._warehouseLocationSelector; } private _warehouseLocationSelector: warehouseLocationSearchSelectorViewModel;
    public set isChecked(v: boolean) { this._isChecked = v; } public get isChecked(): boolean { return this._isChecked; } private _isChecked: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName; } private _personnelName: string;
    public set warehouseCheckUpId(v: string) { this._warehouseCheckUpId = v; } public get warehouseCheckUpId(): string { return this._warehouseCheckUpId;} private _warehouseCheckUpId: string;
    public set checkTime(v: moment.Moment) { this._checkTime = v; } public get checkTime(): moment.Moment { return this._checkTime;} private _checkTime: moment.Moment;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
        

    setWarehouseId(warehouseId: string) {
        this.warehouseId = warehouseId;
        this.warehouseLocationSelector = new warehouseLocationSearchSelectorViewModel(this, warehouseId);
        this.warehouseLocationSelector.onSelectionChanged = x => {
            let location = new Location(this);
            location.id = x.id;
            location.name = x.title;
            this.currentWarehousePlaces.push(location);
        };
    }

    updateNewLocations(locationIds: { Id: string, Name: string }[]) {
        this.currentWarehousePlaces.update(...locationIds.map(item => {
            let location = new Location(this);
            location.id = item.Id;
            location.name = item.Name;
            return location;
        }));
    }

    removeNewLocation(location: Location) {
        this.currentWarehousePlaces.remove(location);
    }

    async confirm(): Promise<void> {
        try {
            this.isLoading = true;
            let confirmResult = await this.messageBoxWarningYesNo("تغییرات ذخیره شود؟", "بررسی دوره ای انبار");
            if (confirmResult == 'no') {
                return;
            }

            let result = await ServerConnection.callServer("Complex/WarehouseServices/UpdateWarehouseCheckUp", {
                ItemId: this.id,
                WarehouseCheckUpId : this.warehouseCheckUpId,
                NewBalance: this.newBalance,
                NewPlaces: this.currentWarehousePlaces.map(item => item.id),
                Comment:this.comment
            });

            if (result.IsSuccessful == true) {
                await this.messageBoxConfirmSuccess("تغییرات با موفقیت ذخیره شد.", "بررسی دوره ای انبار");
                this._typedParent.refresh();
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

}

export class Location extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: WarehouseCheckUp) {
        super(parent);
        this._parent = parent;
        this.isChecked = parent.isChecked;
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set isChecked(v: boolean) { this._isChecked = v; } public get isChecked(): boolean { return this._isChecked; } private _isChecked: boolean;

    private _parent: WarehouseCheckUp;

    async remove() {
        this._parent.removeNewLocation(this);
    }
}

export class PrintUncheckedWarehouseCheckUp {
    constructor(parent: ViewModel) {
        this._parent = parent;
    }
    private _parent;
    public set showProductIndexOnPrint(v: boolean) { this._showProductIndexOnPrint = v; } public get showProductIndexOnPrint(): boolean { return this._showProductIndexOnPrint;} private _showProductIndexOnPrint: boolean;

    public async Print(numberOfRecord): Promise<void> {
        try {
            let result = await ServerConnection.callServer('/Complex/SettingServices/GetShowProductIndexOnPrintSetting',{});
                this.showProductIndexOnPrint = result.ShowProductIndexOnPrint;
        } catch (ex) {
            console.log(ex);
        }
        let serverResult = await ServerConnection.callServer("Complex/WarehouseServices/GetWorkerWarehouseCheckUps", {
            FilteringInformation: { "PaginationInfo": { "PageNo": 1, "PageSize": numberOfRecord }, "OrderInfo": [], "Filters": { "FilterString": "" } },
            IsForPrint : true
        });

        let uncheckedWarehouseCheckUps = serverResult.WarehouseCheckUps;
        let converter = new Converters();
        let data = <any>{
            ShowProductIndexOnPrint : this.showProductIndexOnPrint,
            WarehouseCheckUps: uncheckedWarehouseCheckUps.map((checkUp, index) => {
                return {
                    RowNumber: index + 1,
                    PersonnelName: checkUp.PersonnelFullName,
                    CreationTime : converter.onlyDateNoWeekDayPersianDateConverter(checkUp.CreationTime),
                    ProductName: checkUp.ProductName,
                    ProductCode: checkUp.ProductCode,
                    ProductIndex: checkUp.ProductIndex,
                    BrandName: checkUp.BrandName,
                    CountryName : checkUp.CountryName,
                    CarModelName : checkUp.CarModelName,
                    ColorName : checkUp.ColorName,
                    WarehouseName : checkUp.WarehouseName,
                    OldBalance : checkUp.Balance,
                    OldWarehousePlaces : checkUp.Locations
                }
            })
        };
        var message = new SendToLocalNotificationMessage("requestPrint", {
            Form: "WarehouseCheckUp",
            Data: data
        });
        return this._parent.handleMessage(message);
    }
}